import React from "react";
import { SelectOptionType } from "types/select/SelectOptionType";
import Select, { SingleValue } from "react-select";
import { CustomLabel } from "../input/CustomLabel";
import { InputErrorMessage } from "../input/InputErrorMessage";
import { Controller, Control, UseFormRegister, UseFormSetValue } from "react-hook-form";

type CustomSelectWithoutValidationProps = {
  usarValidacaoParaFormulario: false;
};

type CustomSelectWithValidationProps = {
  usarValidacaoParaFormulario: true;
  /**Nome do atributo que será usado no formulario para realizar as validacoes*/
  name: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

type CustomSelectProps = {
  id: string;
  options: SelectOptionType<any>[];
  className?: string;
  label?: string;
  placeholder?: string;
  isDisabled?: boolean;
  isClearable?: boolean;
  onChange?: (opcaoSelecionada: SingleValue<SelectOptionType<any>>) => void;
  defaultValue?: SingleValue<SelectOptionType<any>>;
  value?: SingleValue<SelectOptionType<any>>;
} & (CustomSelectWithoutValidationProps | CustomSelectWithValidationProps);

const CustomSelect: React.FC<CustomSelectProps> = (props) => {
  const getCustomStyle = (possuiErro: boolean): object => {
    return {
      control: (provided: any, state: any) => ({
        ...provided,
        borderColor: possuiErro
          ? "#dc3545 !important"
          : state.isFocused
          ? "#83cf9c !important"
          : "#c4c4c4",
        boxShadow: "none",
        fontSize: "small",
        fontWeight: "200",
      }),
    };
  };

  const renderSelectComValidacao = () => {
    if (props.usarValidacaoParaFormulario) {
      return (
        <Controller
          name={props.name}
          control={props.control}
          defaultValue={props.defaultValue}
          render={({ field, fieldState }) => (
            <>
              {props.label && (
                <CustomLabel possuiErro={fieldState.error != null}>{props.label}</CustomLabel>
              )}
              <Select
                {...props.register(props.name)}
                {...field}
                id={props.id}
                styles={getCustomStyle(fieldState.error != null)}
                blurInputOnSelect
                closeMenuOnSelect
                isClearable={props.isClearable}
                className={props.className || ""}
                isDisabled={props.isDisabled}
                placeholder={props.placeholder || ""}
                noOptionsMessage={() => "Nenhum registro foi encontrado"}
                options={props.options}
                value={field.value || null}
                onChange={(opcaoSelecionada: SingleValue<SelectOptionType<any>>) => {
                  field.onChange(opcaoSelecionada);
                  props.setValue(props.name, opcaoSelecionada);
                  props.onChange && props.onChange(opcaoSelecionada);
                }}
              />
              {fieldState.error && (
                <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>
              )}
            </>
          )}
        />
      );
    }
  };

  const renderSelectSemValidacao = () => {
    if (!props.usarValidacaoParaFormulario) {
      return (
        <>
          {props.label && <CustomLabel possuiErro={false}>{props.label}</CustomLabel>}
          <Select
            id={props.id}
            styles={getCustomStyle(false)}
            blurInputOnSelect
            closeMenuOnSelect
            isClearable={props.isClearable}
            className={props.className || ""}
            isDisabled={props.isDisabled}
            placeholder={props.placeholder || ""}
            noOptionsMessage={() => "Nenhum registro foi encontrado"}
            options={props.options}
            value={props.value}
            defaultValue={props.defaultValue}
            onChange={(opcaoSelecionada: SingleValue<SelectOptionType<any>>) =>
              props.onChange && props.onChange(opcaoSelecionada)
            }
          />
        </>
      );
    }
  };

  return (
    <div>
      {props.usarValidacaoParaFormulario && renderSelectComValidacao()}
      {!props.usarValidacaoParaFormulario && renderSelectSemValidacao()}
    </div>
  );
};
export default CustomSelect;
